module.exports = __webpack_public_path__ + "static/media/logo.b2b89362.svg";